<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ppp-cactus007htmlprologue">
<p class="ct"><a class="xref" href="#/pppcactus005#ppp-cactus005htmltoc">Prologue</a></p>
<p class="pf">I didn’t know if I would ever tell this story. It was 1999, a strange time, not long after I had returned to Phoenix. Everybody seemed flush, pundits predicted the Dow would reach 36,000, and even deputies day-traded stocks. Health-conscious yuppies smoked fifty-dollar Churchills in plush cigar bars, and the Internet was everywhere. Peralta kept giving me work at the Sheriff’s Office, and I was spending my nights with a young woman named Lindsey. Later, what happened next would seem like a dream, like another man’s life. I would never have gotten into such troubles. But I did. This is how it happened.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-cactus007.vue?269748d6